
import { Row } from './Row'
import { SpacerWidget } from './SpacerWidget'
import { UnknownWidget } from './UnknownWidget'

import { CheckboxReadWidget } from './CheckboxWidget'
import { DateReadWidget } from './DateWidget'
import { DropdownReadWidget } from './DropdownWidget'
import { ListReadWidget } from './ListWidget'
import { MapReadWidget } from './MapWidget'
import { MediaReadWidget } from './MediaReadWidget'
import { TextReadWidget } from './TextWidget'
import { UserReadWidget } from './UserWidget'

const ReadWidgets = {

    row: Row,
    spacer: SpacerWidget,
    unknown: UnknownWidget,

    checkbox: CheckboxReadWidget,
    'checkbox-group': CheckboxReadWidget,
    date: DateReadWidget,
    dropdown: DropdownReadWidget,
    list: ListReadWidget,
    map: MapReadWidget,
    media: MediaReadWidget,
    text: TextReadWidget,
    title: TextReadWidget,
    user: UserReadWidget
}

export {
    ReadWidgets
}
